import axios from "./axios";
import type { Notification } from "../types";
import { firebaseConfig, messaging } from "../firebase/firebase";
import { getToken, isSupported } from "firebase/messaging";
import { NotificationType } from "../enums/notifications.enum";

export const getNotifications = async (offset: number): Promise<any> => {
  try {
    const notificationsTypes = [
      NotificationType.EVENT_JOIN_REQUEST,
      NotificationType.ENTITY_PROFILE_VIEWED,
      NotificationType.FOLLOW,
    ];

    const response = await axios.get<{
      data: {
        items: Notification[];
        total: number;
      };
      // }>(`/users/notifications?limit=10&offset=${offset}&category=general&type=${notificationTypesSeparatedByComma}`);
    }>(`/users/notifications?limit=10&offset=${offset}&category=general`);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to create event");
  }
};

const createPushToken = async (body: any) => {
  try {
    const response = await axios.post<any>(`/users/push-token`, body);
    return response.data;
  } catch (err) {}
};

const generateUniqueId = () => {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const timestamp = Date.now().toString();
  const random = Math.random().toString(36).substring(2, 15);

  return `${btoa(userAgent)}-${platform}-${timestamp}-${random}`;
};

const getPersistentDeviceId = (): string => {
  const STORAGE_KEY = "GOALNGO_DEVICE_ID";
  let deviceId = localStorage.getItem(STORAGE_KEY);

  if (!deviceId) {
    deviceId = generateUniqueId();
    localStorage.setItem(STORAGE_KEY, deviceId);
  }

  return deviceId;
};

const deviceId = getPersistentDeviceId();

export const requestPermission = async () => {
  try {
    const supported = await isSupported().catch(() => false);
    if (!supported) {
      return;
    }

    // Ensure SW is registered and pass it to getToken
    let registration = await navigator.serviceWorker.getRegistration().catch(() => undefined);
    if (!registration) {
      registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js").catch((err) => {
        return undefined;
      });
    }
    if (registration) {
    }
    try {
      const ready = await navigator.serviceWorker.ready;
      registration = ready;
    } catch {}

    const token = await getToken(messaging, {
      vapidKey: "BAL_iQYwsbOWtDFgDCihMXAYbQKlyiPXQ7k5UU8y4sfUhOaqOiHT4VeOw6ShaYOCxs8O4CdxDW9a5Zl64ZnGSxA",
      serviceWorkerRegistration: registration,
    });

    if (token) {
      await createPushToken({ pushToken: token, deviceId }).then(() => {});
    }
  } catch (err) {}
};

export const updateLastSeenNotifications = async (body: any) => {
  try {
    const response = await axios.patch(`/users/last-seen-notifications`, body);
    return response;
  } catch (err: any) {
    if (err.response.data.errors) throw new Error(err.response.data.errors);
    throw new Error(err + " Failed in register your entity API");
  }
};

export const getLastSeenNotifications = async (): Promise<any> => {
  try {
    const response = await axios.get<any>(`/users/last-seen-notifications`);
    return response.data.data.categoriesLastSeen.general;
  } catch (err) {
    throw new Error(err + " Failed to create event");
  }
};

export const deletePushNotifications = async (): Promise<any> => {
  try {
    await axios.delete<any>(`/users/push-token/${deviceId}`);
    localStorage.removeItem("GOALNGO_DEVICE_ID");
  } catch (err) {
    throw new Error(err + " Failed to delete push notification");
  }
};
